import store from '../store/store';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
import { select } from 'satcheljs/lib/legacy';
var arrayEquals = require('array-equal');
export default select({
    optionState: function () { return store; },
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
})(function isBlockedDomainsOptionDirty(state) {
    var _a = state, optionState = _a.optionState, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration;
    if (!mailboxJunkEmailConfiguration || !optionState.blockedDomains) {
        return false;
    }
    return !arrayEquals(optionState.blockedDomains, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !isEmailAddress(item); }));
});
//# sourceMappingURL=isBlockedDomainsOptionDirty.js.map